import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import axiosInstance from "../../../services/axiosComman";
import logout from "../../../utils/Logout";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { NuUpload } from "../../../utils/Inputs";
import Hourglass from "../../../utils/HourGlass";


const Toast = Swal.mixin({
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default function CreateorUpdate({
  data,
  visible,
  onClose,
  refreshData,
}) {

  const [isLoading, setIsLoading] = useState(false);
  const [selectedSQLFile, setSelectedSQLFile] = useState(null);
  const [selectedZIPFile, setSelectedZIPFile] = useState(null);
  const [createNew, setCreateNew] = useState({
    name: "",
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    setCreateNew({
      name: data?.name,
      start_date: data?.start_date,
      end_date: data?.end_date,
    });
  }, [data]);


  function handleZIPChange(e) {
    const files = Array.from(e.target.files);
    setSelectedZIPFile(files);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value, { resetForm }) => {
      setIsLoading(true);

      Swal.fire({
        title: "Confirm Restoration",
        text: `Are you sure you want to restore the backup?. All changes performed after the backup date / time will be lost. Click on Restore button to proceed.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d5d5d5",
        confirmButtonText: "Restore",
        width: "45%",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let formData = new FormData();
          if (selectedSQLFile !== null) {
            selectedSQLFile.forEach((file) => {
              formData.append("sql_file", file);
            });
          }
          if (selectedZIPFile !== null) {
            selectedZIPFile.forEach((file) => {
              formData.append("zip_file", file);
            });
          }
          axiosInstance
            .post(`/Auth/upload_backup_file`, formData)
            .then((res) => {
              if (res.data) {
                setTimeout(() => {
                  setIsLoading(false);
                  resetForm();
                  setSelectedZIPFile(null);
                  setSelectedSQLFile(null);
                  refreshData();
                  Toast.fire({
                    icon: "success",
                    title: res.data.msg || "Manual Restore Successfully",
                  });
                  onClose();
                  logout();
                }, 90000);
              } else {
                setIsLoading(false);
                Toast.fire({
                  icon: "error",
                  title: res.data.msg || "Manual Restore Unsuccessfully",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              Toast.fire({
                icon: "error",
                title:
                  err?.response.data.msg ||
                  err?.response.data.error ||
                  "Manual Restore Unsuccessfully",
              });
            });
        } else {
          setIsLoading(false);
          onClose();
        }
      });
    },
  });

  if (!visible) return null;
  return (
    <>
      <div
        id="modal"
        // onClick={handleOnClose}
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-4/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              Manual Restore
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={onClose}
            >
              {/* <img src={Close} alt="close" title="close" /> */}
              <svg
                className="w-7 h-7"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.842773"
                  y="0.560791"
                  width="51.1569"
                  height="51.1569"
                  rx="5"
                  fill="#7030A0"
                />
                <path d="M26.4219 26.1392L18.8794 33.6816Z" fill="#6E6985" />
                <path
                  d="M33.9643 33.6816L26.4219 26.1392M26.4219 26.1392L18.8794 18.5967M26.4219 26.1392L33.9643 18.5967M26.4219 26.1392L18.8794 33.6816"
                  stroke="white"
                  stroke-width="2.3"
                  stroke-linecap="round"
                />
                <title>Close</title>
              </svg>
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className=" z-50 ">
              <div className="relative px-6 pb-6 flex gap-3 flex-wrap justify-between">

                <NuUpload
                  name="zip_file"
                  label="Backup Tar.gz File"
                  // isRequired={true}
                  width="w-full"
                  onChange={handleZIPChange}
                  accept={"application/gzip, application/x-gzip, application/x-tar, .gz, .tar, .tar.gz"}
                />
              </div>
              <div className=" w-full flex flex-wrap my-3">
              </div>
              <div className="flex items-center justify-end px-6 py-6 rounded-b text-xs 2xl:text-sm">
                <button
                  onClick={onClose}
                  className={`${
                    isLoading ? " bg-slate-400 cursor-wait" : "bg-text"
                  }  hover:shadow-menu text-white px-6 py-2 mr-2 rounded-3xl`}
                  disabled={isLoading ? true : false}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isLoading ? true : false}
                  className={` ${
                    isLoading ? " bg-purple-400 cursor-wait" : "bg-primary"
                  } hover:shadow-button text-white px-6 py-2 mr-2 rounded-3xl`}
                >
                  Restore
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {isLoading && (
        <Hourglass title={"Manual restore in progress…"} message={"After the restoration is complete, the system will automatically log out. Please log back in after 3 minutes."}/>

      )}
    </>
  );
}
